import { Brand, NavbarStyled } from "./navbar.styles";
import logo from "../../../../assets/images/logo.png";
import { Typography } from "@mui/material";

const Navbar = () => {
  return (
    <NavbarStyled className="navbar-wrapper">
      <Brand>
        <img src={logo} alt="Logo" />
        <Typography>Chasing Tails</Typography>
      </Brand>
    </NavbarStyled>
  );
};

export default Navbar;
